import {
  FILE_TYPES,
  GET_ACCOUNTANT_FILE,
  GET_ACCOUNTANT_FILE_SEPARATED_BY_ACCOUNT_TITLE,
  GET_EXCEL_FILE,
  GET_EXCEL_FILE_SEPARATED_BY_ACCOUNT_TITLE,
  GET_EXCEL_FILE_WITH_BUDGET_COMPARISON,
  GET_PDF_FILE,
  GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITH_APPENDIX,
  GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITH_APPENDIX_DETAILED,
  GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITHOUT_APPENDIX,
  GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITHOUT_APPENDIX_DETAILED,
  GET_PDF_FILE_WITH_APPENDIX,
  GET_PDF_FILE_WITH_BUDGET_COMPARISON,
  GET_PDF_FILE_WITHOUT_APPENDIX
} from "../../../../../constants/file";
import {
  IMPREST_BUDGET_BY_ACCOUNT_TITLE_API,
  IMPREST_BY_ACCOUNT_TITLE_API,
  IMPREST_BY_ACCOUNT_TITLE_WITH_DETAIL_API,
  IMPRESTS_API
} from "../../../../../constants/api";
import GetFilter from "../filter";
import { GetAccountTitlesFilter as GetBudgetFilter } from "../../../../pettyCashBudget/filter";
import { DownloadFileAction } from "../../../../../actions";

const filters = (id, add_appendix) => GetFilter(id, add_appendix);
const budgetFilters = id => GetBudgetFilter(id);
const pdfSubFilesCreator = (id, has_budget, isAdmin) => {
  let subFiles = [
    {
      type: FILE_TYPES.PDF,
      title: GET_PDF_FILE_WITHOUT_APPENDIX,
      route: IMPRESTS_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id, false)
    },
    {
      type: FILE_TYPES.PDF,
      title: GET_PDF_FILE_WITH_APPENDIX,
      route: IMPRESTS_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id, true)
    },
    {
      type: FILE_TYPES.PDF,
      title: GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITHOUT_APPENDIX,
      route: IMPREST_BY_ACCOUNT_TITLE_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id, false)
    },
    {
      type: FILE_TYPES.PDF,
      title: GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITH_APPENDIX,
      route: IMPREST_BY_ACCOUNT_TITLE_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id, true)
    },
    {
      type: FILE_TYPES.PDF,
      title: GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITHOUT_APPENDIX_DETAILED,
      route: IMPREST_BY_ACCOUNT_TITLE_WITH_DETAIL_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id, false)
    },
    {
      type: FILE_TYPES.PDF,
      title: GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITH_APPENDIX_DETAILED,
      route: IMPREST_BY_ACCOUNT_TITLE_WITH_DETAIL_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id, true)
    }
  ];
  if (has_budget) {
    subFiles.push({
      type: FILE_TYPES.PDF,
      title: GET_PDF_FILE_WITH_BUDGET_COMPARISON,
      route: IMPREST_BUDGET_BY_ACCOUNT_TITLE_API,
      isAdmin: isAdmin,
      method: "post",
      filters: budgetFilters(id)
    });
  }
  return subFiles;
};
const excelSubFilesCreator = (id, has_budget, isAdmin) => {
  let subFiles = [
    {
      type: FILE_TYPES.EXCEL,
      title: GET_EXCEL_FILE,
      route: IMPRESTS_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id)
    },
    {
      type: FILE_TYPES.EXCEL,
      title: GET_EXCEL_FILE_SEPARATED_BY_ACCOUNT_TITLE,
      route: IMPREST_BY_ACCOUNT_TITLE_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id)
    }
  ];
  if (has_budget) {
    subFiles.push({
      type: FILE_TYPES.EXCEL,
      title: GET_EXCEL_FILE_WITH_BUDGET_COMPARISON,
      route: IMPREST_BUDGET_BY_ACCOUNT_TITLE_API,
      isAdmin: isAdmin,
      method: "post",
      filters: budgetFilters(id)
    });
  }
  return subFiles;
};

const accountantSubFilesCreator = (id, isAdmin) => {
  return [
    {
      type: FILE_TYPES.ACCOUNTANT,
      title: GET_ACCOUNTANT_FILE,
      with_date: true,
      route: IMPRESTS_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id)
    },
    {
      type: FILE_TYPES.ACCOUNTANT,
      title: GET_ACCOUNTANT_FILE_SEPARATED_BY_ACCOUNT_TITLE,
      with_date: true,
      route: IMPREST_BY_ACCOUNT_TITLE_API,
      isAdmin: isAdmin,
      method: "post",
      filters: filters(id)
    }
  ];
};

export const getFileHandleClick = (id, isAdmin, type, has_budget) =>
  DownloadFileAction.modalData([
    {
      type: FILE_TYPES.PDF,
      title: GET_PDF_FILE,
      subFiles: pdfSubFilesCreator(id, has_budget, isAdmin)
    },
    {
      type: FILE_TYPES.EXCEL,
      title: GET_EXCEL_FILE,
      subFiles: excelSubFilesCreator(id, has_budget, isAdmin)
    },
    {
      type: FILE_TYPES.ACCOUNTANT,
      title: GET_ACCOUNTANT_FILE,
      subFiles: accountantSubFilesCreator(id, isAdmin)
    }
  ]);
